import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { paths } from '../../common/constants/pathVariables.js';
import { quotesMsg, t } from '../../common/i18n/index.js';
import { isStrictFeatureEnabled } from '../../common/utils/featureFlagUtils.js';
import { useFeatureFlags } from '../../public/site/ConfigProvider.js';
import { resetErrors } from '../../selfservice/actions/index.js';
import { HeroHeading, HeroHeadingType } from '../HeroHeading/index.js';
import { LocalNavi } from '../LocalNavi/index.js';
import { SystemError } from '../SystemError/SystemError.js';
import type { CommonError } from '../../common/types/errors.js';
import type { BreadCrumbList } from '../BreadCrumbs/index.js';
import type { LocalNaviItem } from '../LocalNavi/index.js';
import type { ReactNode } from 'react';

interface ProductOfferingsLayoutPropsCoCo {
  breadCrumbs?: BreadCrumbList;
  children?: ReactNode;
  errors?: CommonError[];
}

export const getDisplayCategories = (cocoProposalManagementEnabled: boolean) => {
  return [
    cocoProposalManagementEnabled && {
      children: t.J63R(quotesMsg),
      to: paths.PS_QUOTES,
    },
  ].filter(Boolean) as LocalNaviItem[];
};

export const ProductOfferingsLayoutCoCo = ({ breadCrumbs, children, errors }: ProductOfferingsLayoutPropsCoCo) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { cocoProposalManagement } = useFeatureFlags();
  const cocoProposalManagementEnabled = isStrictFeatureEnabled(cocoProposalManagement);
  if (errors?.length) {
    return (
      <SystemError
        errors={errors}
        onButtonClick={() => {
          dispatch(resetErrors());
          navigate(paths.SELF_SERVICE_HOME);
        }}
      />
    );
  }

  const displayCategories = getDisplayCategories(cocoProposalManagementEnabled);

  return (
    <div className="of-subscriptions-scene">
      <HeroHeading
        breadCrumbPaths={breadCrumbs}
        heroHeadingType={HeroHeadingType.SUBSCRIPTIONS}
        title={t.J63R(quotesMsg)}
      />
      <LocalNavi wide categories={displayCategories} />
      {children}
    </div>
  );
};
